import { create } from 'zustand';

import { IUserInfoResponse } from '../api/userInfo';

export type TUserInfoStore = Pick<
  IUserInfoResponse,
  | 'displayName'
  | 'isSejami'
  | 'hasUpdatedSejamInfo'
  | 'isInTseMarket'
  | 'clubTotalRial'
  | 'birthDate'
>;
interface IUserInfoStore {
  data?: TUserInfoStore;
  setter: (data?: TUserInfoStore) => void;
}

export const useUserInfoStore = create<IUserInfoStore>((set) => ({
  data: undefined,
  setter: (data) => {
    set({ data });
  },
}));
